<template>
  <form
    ref="form"
    data-url="/complianceCommitment"
    :class="{ 'loading-opacity': preloader }"
  >
    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5 v-html="$store.getters.getTag('6')"></h5>
      </legend>

      <p class="col-12" v-html="tag61"></p>
    </div>

    <div class="row">
      <div class="col-12">
        <app-note
          class="mb-primary"
          :show-title="false"
          content-type="html"
          :notes="[$store.getters.getTag('6.I.1')]"
        />
      </div>

      <div class="col-md-12">
        <table id="compliance-commitment">
          <tr v-for="(value, key) in inputs.data" :key="key">
            <td class="name">
              {{ value.compliance_commitment.name }}
              <b
                v-if="value.compliance_commitment.is_required"
                class="text-danger ml-2"
                style="font-size: 18px !important"
                >*</b
              >
            </td>
            <td class="is-checked">
              <input
                type="checkbox"
                v-model="value.is_checked"
                :disabled="disabled"
              />
            </td>
          </tr>
        </table>
      </div>
    </div>
    
    <p class="col-12" v-html="$store.getters.getTag('6.F')"></p>

    <p class="col-12" v-html="$store.getters.getTag('6.D')"></p>

    <p class="col-12" v-html="$store.getters.getTag('6.C')"></p>

    <div class="row mt-3">
      <div class="col-12 col-md-6">
        <div class="form-group">
          <label
            >Ciudad donde Firma<b
              class="text-danger ml-2"
              style="font-size: 18px !important"
              >*</b
            ></label
          >
          <app-input
            type="text"
            v-model="inputs.accApp.city_where_sign"
            :disabled="disabled"
            placeholder="Ingrese la ciudad donde firma"
            :required="true"
          />
        </div>
      </div>
    </div>

    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />

    <div class="row" v-if="!disabled">
      <div class="col-12 mt-3">
        <button
          type="submit"
          class="btn btn-primary mr-2"
          @click.prevent="submit"
        >
          {{ $t("save") }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "#/Accreditation/Resources/assets/js/apiUrl";
export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {
        accApp: {},
      },
      attached_file: null,
      deleteModal: false,
      delete_file: false,
      pdf: "/common/pdf/complianceCommitment?accreditation_application_id=",
    };
  },

  computed: {
    status() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.status.code
        : null;
    },

    activity() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.accreditation_activity.code
        : null;
    },

    disabled() {
      return this.status != "100" && this.status != "112";
    },

    org() {
      return this.inputs.accApp ? this.inputs.accApp.organization : null;
    },

    user() {
      return this.inputs.accApp ? this.inputs.accApp.user : null;
    },

    tag61() {
      let tmp = this.$store.getters.getTag("6.1");

      const lr = { name: "_____", taxid: "_____" };
      if (this.inputs.accApp.id) {
        if (this.org && this.org.legal_representative) {
          lr.name = this.org.legal_representative;
          lr.taxid = this.org.legal_representative_taxid;
        } else {
          lr.name = `${this.user.first_name} ${this.user.last_name}`;
          lr.taxid = this.user.taxid;
        }
      }
      tmp = tmp.replace("[name]", lr.name);
      tmp = tmp.replace("[taxid]", lr.taxid);
      tmp = tmp.replace(
        "[oc]",
        this.org
          ? this.org.business_name
            ? this.org.business_name
            : "_____"
          : "_____"
      );
      return tmp;
    },
  },

  created() {
    this.pdf = this.pdf + this.$store.state.accreditation.id;
    this.data();
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      let formData = new FormData();
      formData.append("city_where_sign", this.inputs.accApp.city_where_sign);
      let i = 0;
      let j = 0;
      for (let index = 0; index < this.inputs.data.length; index++) {
        formData.append("id[]", this.inputs.data[index].id);
        formData.append(
          "is_checked[]",
          this.inputs.data[index].is_checked ? 1 : 0
        );
        let dato1 = this.inputs.data[index].is_checked ? 1 : 0;
        let dato2 = this.inputs.data[index].compliance_commitment.is_required ? 1 : 0;
        if (dato2) {
          if (!dato1) {
            this.$toastr.e("Debe seleccionar los compromisos que son obligatorios (*)");
            return;
          }
        }
        i += this.inputs.data[index].is_checked ? 1 : 0;
        j += this.inputs.data[index].compliance_commitment.is_required ? 1 : 0;
      }
      // if (i != j) {
      //   this.$toastr.e(
      //     "Debe seleccionar los compromisos que son obligatorios (*)"
      //   );
      //   return;
      // }

      // formData.append("file", this.inputs.file);
      // if (this.delete_file) {
      //   formData.append("delete_file", true);
      // }
      formData.append(
        "accreditation_application_id",
        this.$store.state.accreditation.id
      );
      this.save(formData);
    },

    afterSuccess(res) {
      // this.$toastr.s(res.data.message);
      const data = res.data;

      if (data.length > 0) {
        const accApp = data[0].accreditation_application;
        this.inputs = {
          data: data,
          accApp: accApp,
        };
      }

      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {
      this.preloader = true;
      this.axiosGet(
        `${actions.COMPLIANCE_COMMITMENT}/show?accreditation_application_id=${this.$store.state.accreditation.id}`
      )
        .then((response) => {
          if (response.status == 200) {
            const data = response.data;

            if (data.length > 0) {
              const accApp = data[0].accreditation_application;
              this.inputs = {
                data: data,
                accApp: accApp,
              };

              // this.attached_file = accApp.compliance_commitment_attached_file
              //   ? accApp.compliance_commitment_attached_file
              //   : null;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },

    confirmed() {
      this.deleteModal = false;
      // this.inputs.file = null;
      this.$set(this.inputs, "file", null);
      this.attached_file = null;
      this.delete_file = true;
    },

    cancelled() {
      this.deleteModal = false;
    },

    openTab(type) {
      let w;
      if (type == "a") {
        w = window.open(this.pdf, "_blank");
      } else if (type == "b") {
        w = window.open(this.attached_file.path, "_blank");
      }
      w.focus();
    },
  },
};
</script>
<style lang="css">
#compliance-commitment {
  width: 100%;
}
#compliance-commitment tr {
  border: 1px dotted gray;
}
#compliance-commitment td {
  padding: 0.8rem;
}
#compliance-commitment .name {
  text-align: justify;
}
#compliance-commitment .is-checked {
  width: 5%;
  text-align: center;
}
</style>